
import { apiHelper } from "../apiHelper/apiHelper";
import {
  getComplainFailure,
  getComplainRequest,
  getComplainSuccess,
} from "../slices/complainSlices";

// ========================== NEW API HANDLER =================

// get Farmers list
export const handleGetComplainList = async (dispatch) => {
  const endPoint = "user/get-all-complains";
  const method = "GET";
  const state1 = getComplainRequest;
  const state2 = getComplainSuccess;
  const state3 = getComplainFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};
